import type { SeatLayoutDetail, SeatLayoutSeat } from "../../../api/services/seat-layout.service";
import { createClientKey } from "../core/draft";
import type { LayoutStudioDraft } from "../core/types";
import type { ReservationPackage, ReservationPackageResponse } from "./types";

const defaultTier = () => ({
  client_key: createClientKey("tier"),
  name: "기본 존",
  color: "#111827",
  display_order: 1,
});

export const normalizeReservationPackage = (item: ReservationPackageResponse): ReservationPackage => ({
  id: item.id,
  name: item.name || item["상품명"] || `상품 ${item.id}`,
  has_spots: Boolean(item.has_spots),
  spots: Array.isArray(item.spots) ? item.spots : [],
});

export const buildInitialDraft = (reservationPackage: ReservationPackage, existing?: SeatLayoutDetail | null): LayoutStudioDraft => {
  if (existing) {
    return {
      id: existing.id,
      name: existing.name,
      reservation_package: existing.reservation_package,
      canvas_width: existing.canvas_width,
      canvas_height: existing.canvas_height,
      background_image_url: existing.background_image_url,
      status: existing.status,
      version: existing.version,
      packages: existing.packages.map((item, index) => ({
        ...item,
        display_order: item.display_order || index + 1,
      })),
      seats: existing.seats.map((seat, index) => ({
        ...seat,
        label: seat.label || seat.spot_name || `S-${index + 1}`,
      })),
    };
  }

  const tier = defaultTier();
  const columns = Math.max(4, Math.ceil(Math.sqrt(reservationPackage.spots.length || 1)));

  return {
    name: `${reservationPackage.name} 좌석도`,
    reservation_package: reservationPackage.id,
    canvas_width: 1200,
    canvas_height: 820,
    background_image_url: "",
    status: "draft",
    version: 0,
    packages: [tier],
    seats: reservationPackage.spots.map((spot, index) => ({
      spot: spot.id,
      spot_name: spot.name,
      label: spot.name,
      seat_type: "standard",
      x: 64 + (index % columns) * 88,
      y: 72 + Math.floor(index / columns) * 88,
      width: 64,
      height: 48,
      rotation: 0,
      display_order: index + 1,
      is_active: true,
      layout_package_client_key: tier.client_key,
      meta: null,
    })),
  };
};

export const findTierColor = (draft: LayoutStudioDraft | null, seat: SeatLayoutSeat) => {
  if (!draft) {
    return "#111827";
  }

  const tier = draft.packages.find(
    (item) => item.id === seat.layout_package || item.client_key === seat.layout_package_client_key,
  );
  return tier?.color || "#111827";
};
